import { useQuery, useMutation } from 'react-query'
import API from '.'
import { serializeQuery } from './utils'

const ENDPOINT = '/api/company-mapping'
const QUERY_KEY = 'company-mapping'

export const useGetCompanyMappings = (query = {}, config = {}) =>
  useQuery(
    [QUERY_KEY, query],
    async () => (await API.get(serializeQuery(ENDPOINT, query))).data,
    config
  )

export const usePostCompanyMapping = (config = {}) =>
  useMutation((newData) => API.post(ENDPOINT, newData), config)

export const usePatchCompanyMapping = (config = {}) =>
  useMutation((updatedData) => API.patch(ENDPOINT, updatedData), config)

export const useDeleteCompanyMapping = (config = {}) =>
  useMutation((id) => API.delete(ENDPOINT, { data: id }), config)

export const useGetCompanyMappingOptions = (config = {}) =>
  useQuery([QUERY_KEY, 'options'], async () => (await API.get(`${ENDPOINT}/options`)).data, config)
